module.exports = __webpack_public_path__ + "img/north-caicos.cce47ee9.jpg";